define('controllers/ispr',['require','johngrid'],function (require) {
    var CreateJohnGrid = require('johngrid');
    return function() {
        $("form").attr("target", "uploadTrg")
                .attr("enctype", "multipart/form-data"); //set form to be posted via the iframe, so we can upload without full page refresh...

        var AJAX_Url = "ISPR_Ajax.aspx",
            grid = CreateJohnGrid(),
            columns = [{ DataField: "Hotel" },
                       { DataField: "Month" },
                       { DataField: "URC_BeginningBalance", HeaderText: "URC Beginning Balance" },
                       { DataField: "URC_EndingBalance", HeaderText: "URC Ending Balance" },
                       { DataField: "FileName", HeaderText: "File" },
                       { DataField: "CreatedBy", HeaderText: "Created By" },
                       { DataField: "CreateDate", HeaderText: "Created" },
                       { DataField: "ClosedBy", HeaderText: "Closed By" },
                       { DataField: "ClosedDate", HeaderText: "Closed" }],
            editTemplate = $("#editTemplate"),
            filterTemplate = $("#filterTemplate"),
            filterHotel = $(".txtSearchHotels", filterTemplate),
            manageISPRFile = $("#manageISPRFile");

        grid.editHelpers.init(editTemplate);
        grid.editHelpers.onEdit = function (item) {
            var closed = $("#chkClosed");
            item.ClosedDate == "" ? closed.prop('checked', false) : closed.prop('checked', true);

            $(".txtSearchHotels", editTemplate).val(item.Hotel).attr("data-selectedValue", item.HotelID);
            SetHotelReportLink(item.HotelID);

            invoiceGrid.databind([]);
            invoiceGrid.databind();

            item.FileName == "" ? manageISPRFile.hide().prev().show().prev().hide() :
                                  manageISPRFile.show().prev().hide().prev().show();

        };
        grid.insertHelpers.init(editTemplate);
        grid.insertHelpers.onAdd = function () {
            SetHotelReportLink(0);
            invoiceGrid.databind([]);
            manageISPRFile.hide().prev().show().prev().hide();
            $("span[data-name='ClosedDate']", editTemplate).text("Close");
        };

        manageISPRFile.on("click", function (e) {
            e.preventDefault();
            manageISPRFile.hide().prev().show().prev().hide();
        });

        grid.sorting.allowSorting = true;
        grid.dsPostValues.sortClause = "CreateDate DESC";
        grid.utilities.validateItem = function (item) {
            var errors = [];
            if (item.hdnSearchHotelsValue == 0) {
                errors.push("Please choose a hotel.");
            }
            if (item.Month.trim() == "") {
                errors.push("Please enter a value for Month.");
            }
            //if (item.URC_BeginningBalance == "" || isNaN(item.URC_BeginningBalance)) {
            //    errors.push("Please enter a number for URC Beginning Balance.");
            //}
            //if (isNaN(item.URC_EndingBalance)) {
            //    errors.push("Please enter a number for URC Ending Balance.");
            //}
            return errors;
        };

        grid.onDataBinding = function () {
            grid.dsPostValues.hotelId = filterHotel.attr("data-selectedValue");
        };

        grid.init($("#tblISPR"), columns, AJAX_Url);
        $(".johnGridHeader", grid.$table).prepend(filterTemplate);

        //replace save button with submit button
        $(".btnSave", editTemplate).remove();
        var newSaveButton = $('<button type="submit" class="btn btn-primary btnSave"> <i class="icon-ok icon-white"></i> Save&nbsp;&nbsp;&nbsp;</button>');
        newSaveButton.on("click", function (e) {
            grid.utilities.clearMessage();
            var item = grid.utilities.getItemFromTemplate(),
                errors = grid.utilities.validateItem(item);
            if (errors.length > 0) {
                e.preventDefault();
                grid.utilities.setError(errors.join("<br />"));
            } else {
                $(this).hide().next().show();
            }
        });
        $(".JohnGridActions", editTemplate).prepend(newSaveButton);
        grid.databind();

        $("iframe").on("load", function () {
            //file uploaded and ISPR record saved...potentially
            $.post(AJAX_Url, { method: "checkSaveStatus" }, function (response) {
                Utilities.handleAJAXResponse(response, function (obj) {
                    grid.databind();
                    grid.utilities.cancelClick(); //when creating new, primary key is empty, so can't stay here, lest they click save again (creates another...)
                    grid.utilities.setInfo("Saved Successfully");
                },
                function (error) {
                    grid.utilities.setError(error);
                });
            }).complete(function () {
                newSaveButton.show().next().hide();
            });
        });

        $("#lstHotels").on("change", function () {
            setUpViewReportsLink($("#lstHotels").val());
        });

        SearchHotels_EventHandlers.onValueSet = function (item) {
            if (IsSearchHotels_Edit.call(this)) {
                SetHotelReportLink(item.value); //only set when edit template's hotel search control changes.

                //if paste in hotel name and click out, the value will not be set. 
                /*TODO:Consider putting the below if conditional into the actual SearchControl's generated js. But instead set a red border or something along those lines.
                        Note that there's still a way to make the change event not happen with a valid value pasted in, though, so the issue would still ultimately be there...
                */
                if (item.value == 0 && $(this).val().trim() != "") {
                    $("#SearchHotelError").show().text("THE VALUE WAS NOT SET PROPERLY. Please pick an item from the search results, below the box.");
                } else {
                    $("#SearchHotelError").hide();
                }
            }
        };

        SearchHotels_EventHandlers.onChange = function (item) {
            if (IsSearchHotels_Edit.call(this)) {
                invoiceGrid.databind([]);
                if (item.value != 0) {
                    invoiceGrid.databind();
                }
            }
        };
        function IsSearchHotels_Edit() {
            return $(this).prop('id') != filterHotel.prop('id');
        }

        function SetHotelReportLink(selectedHid) {
            if (selectedHid != 0) {
                var operateAsHotelPath = "/hotel/ISPR/?hotel=" + selectedHid.toString();
                $("#aViewCurrentReports").show().attr("href", operateAsHotelPath);
            } else {
                $("#aViewCurrentReports").hide();
            }
            $("input[name='HotelId']", editTemplate).val(selectedHid);
        }

        $("#txtMonth").datepicker({
            format: "m-yyyy",
            viewMode: "months",
            minViewMode: "months"
        });

        var invoiceGrid = CreateJohnGrid(),
            invoiceColumns = [{ DataField: "Assign" },
                              { DataField: "FolioNumber", HeaderText: "Folio" },
                              { DataField: "InvoiceNumber", HeaderText: "Invoice Number" },
                              { DataField: "EMail", HeaderText: "Member" },
                              { DataField: "InvoiceDate", HeaderText: "Invoice Date" },
                              { DataField: "CreateDate", HeaderText: "Created" },
                              { DataField: "ModifiedDate", HeaderText: "Last Modified" },
                              { DataField: "Comments" }],
            invoiceAJAX = "ISPR_Invoice_Selection_AJAX.aspx";

        invoiceGrid.init($("#tbl_Invoices"), invoiceColumns, invoiceAJAX);
        invoiceGrid.onDataBinding = function () {
            invoiceGrid.dsPostValues.ISPR_ID = $("input[name='PrimaryKey']", editTemplate).val();
            invoiceGrid.dsPostValues.HotelId = $(".txtSearchHotels", editTemplate).attr("data-selectedValue");
        };

        //qs report requested...
        if (window.ServerData.feData.ISPR_Details != undefined) {
            grid.editHelpers.$editTemplate.show();
            //fill form and show
            grid.utilities.gridMode = grid.utilities.gridModes.editing;
            grid.utilities.selectedItem = window.ServerData.feData.ISPR_Details;
            grid.utilities.clearForm();
            grid.utilities.clearMessage();
            grid.selectHelpers.fillForm(function () {
                grid.editHelpers.onEdit(grid.utilities.selectedItem);
            });
        } else {
            filterHotel.focus();
        }

        Utilities.setDefaultButton(filterTemplate, $(".btnRefresh", grid.$table));

    };
});
